import React, { createContext, FC, useCallback, useState } from 'react';
import { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';

interface BracketControlsContextProps {
  transformComponent?: ReactZoomPanPinchRef | null;
  onRefChange?: (node: ReactZoomPanPinchRef | null) => void;
}

export const BracketControlsContext = createContext<BracketControlsContextProps>({
  transformComponent: undefined,
});

export const BracketControlsProvider: FC = ({ children }) => {
  const [transformComponent, setTransformComponent] = useState<ReactZoomPanPinchRef | null>(null);

  const onRefChange = useCallback(
    (node: ReactZoomPanPinchRef | null) => {
      setTransformComponent(node);
    },
    [setTransformComponent]
  );

  return (
    <BracketControlsContext.Provider value={{ transformComponent, onRefChange }}>
      {children}
    </BracketControlsContext.Provider>
  );
};
